/* ASC minimum order quantity (MOQ) — restored 9/25/2026.
   The previous theme enforced the product's base unit (metafield custom.unit,
   e.g. "CS25" = 25, "PK5" = 5, "Each" = 1) on the cart drawer and cart page
   (GTECT's cart.js, Vision theme). This theme shipped without it, so single
   units reached NetSync and posted to NetSuite as fractions of a case.
   Rule (same as before): the base unit is the LAST number in custom.unit, a
   trailing K means thousands, "Each"/blank means 1. Quantity is a multiple of
   the base unit and never below it, on the product page, the cart drawer and
   the cart page. Inputs opt in with data-unit="{{ custom.unit }}". */
(function () {
  function baseUnit(u) {
    if (u == null) return 1;
    u = String(u).trim();
    if (!u || /^each$/i.test(u)) return 1;
    var m = u.match(/(\d+)\s*(k)?(?![\s\S]*\d)/i);
    if (!m) return 1;
    var n = parseInt(m[1], 10) || 1;
    if (m[2]) n *= 1000;
    return n > 0 ? n : 1;
  }
  function snap(v, b) {
    v = parseInt(v, 10) || 0;
    if (b <= 1) return Math.max(1, v);
    if (v < b) return b;
    return Math.ceil(v / b) * b;
  }
  function apply(input) {
    var b = baseUnit(input.getAttribute('data-unit'));
    input.dataset.moq = String(b);
    if (b <= 1) return;
    if (input.getAttribute('min') !== String(b)) input.setAttribute('min', String(b));
    if (input.getAttribute('step') !== String(b)) input.setAttribute('step', String(b));
    var v = parseInt(input.value, 10) || 0;
    var s = snap(v, b);
    if (v !== s) { input.value = s; }
  }
  function applyAll(root) {
    var list = (root || document).querySelectorAll('input[data-unit]');
    for (var i = 0; i < list.length; i++) apply(list[i]);
  }
  // Typed values snap before anyone else sees the change (capture phase runs
  // ahead of Dawn's cart handlers and the product page's own listeners).
  function onEdit(e) {
    var i = e.target;
    if (!i || !i.getAttribute || i.getAttribute('data-unit') == null) return;
    var b = baseUnit(i.getAttribute('data-unit'));
    if (b <= 1) return;
    var s = snap(i.value, b);
    if (String(s) !== String(i.value)) i.value = s;
  }
  document.addEventListener('change', onEdit, true);
  document.addEventListener('blur', onEdit, true);
  // A form submit with a quantity input snaps first (product page add to cart).
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.querySelectorAll) return;
    applyAll(f);
  }, true);
  // Cart drawer and cart page re-render their HTML after every update.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return; pending = true;
    setTimeout(function () { pending = false; applyAll(); }, 0);
  }).observe(document.documentElement, { childList: true, subtree: true });
  // The Quantity Break app writes the product-page quantity as a property (no
  // event), so re-snap those inputs on a short poll, like the page's own mirror.
  setInterval(function () {
    var list = document.querySelectorAll('input[name="quantity"][data-unit], #pdp-sticky-qty-input[data-unit]');
    for (var i = 0; i < list.length; i++) {
      var b = baseUnit(list[i].getAttribute('data-unit')); if (b <= 1) continue;
      var s = snap(list[i].value, b);
      if (String(s) !== String(list[i].value)) list[i].value = s;
    }
  }, 400);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { applyAll(); });
  applyAll();
  // Base units for the lines in the cart right now, from templates/cart.moq.liquid
  // (GET /cart?view=moq). The drawer builds its HTML from /cart.js, which carries
  // no metafields. Resolves to { variant_id: unit }.
  function unitsForCart() {
    return fetch('/cart?view=moq', { headers: { 'Accept': 'text/html' }, cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (t) { var s = t.indexOf('{'), e = t.lastIndexOf('}'); return (s >= 0 && e > s) ? JSON.parse(t.slice(s, e + 1)) : {}; })
      .catch(function () { return {}; });
  }
  /* 10/8/2026: the snap above only changed what the box DISPLAYED. A line that
     was already in the cart at 1 (an old saved cart, a reorder, any add that did
     not pass through a snapped form) showed "25" on the cart page while /cart.js
     still said 1, and checkout takes /cart.js. Two web orders (10/5, 10/6) went
     to NetSuite that way and posted as 0.04 of a case. So: make it real. On the
     cart page and in the drawer, read the live cart, and for every line whose
     quantity is below or off its base unit, POST the snapped quantity to
     /cart/change.js. Also run it once more when Checkout is clicked, before
     leaving the page. */
  var normalizing = null;
  function normalizeCart() {
    if (normalizing) return normalizing;
    normalizing = Promise.all([
      fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }),
      unitsForCart()
    ]).then(function (res) {
      var cart = res[0], units = res[1] || {};
      var fixes = [];
      (cart.items || []).forEach(function (it) {
        var b = baseUnit(units[String(it.variant_id)]);
        if (b <= 1) return;
        var s = snap(it.quantity, b);
        if (s !== it.quantity) fixes.push({ key: it.key, from: it.quantity, to: s });
      });
      var chain = Promise.resolve();
      fixes.forEach(function (f) {
        chain = chain.then(function () {
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: f.key, quantity: f.to }) });
        });
      });
      return chain.then(function () { return fixes; });
    }).catch(function () { return []; }).then(function (fixes) { normalizing = null; return fixes; });
    return normalizing;
  }
  function afterNormalize(fixes) {
    if (!fixes.length) return;
    if (/^\/cart\/?$/.test(location.pathname)) {
      // one reload per cart state so the totals and line prices are the real ones
      var tag = fixes.map(function (f) { return f.key + ':' + f.to; }).join(',');
      try { if (sessionStorage.getItem('ascMoqFixed') === tag) return; sessionStorage.setItem('ascMoqFixed', tag); } catch (e) {}
      location.reload();
    } else {
      window.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }
  function startNormalize() { normalizeCart().then(afterNormalize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startNormalize); else startNormalize();
  // Any add to cart (the drawer and the page both announce it) gets the same pass.
  window.addEventListener('cart:refresh', function () { normalizeCart().then(function (fixes) { if (fixes.length) window.dispatchEvent(new CustomEvent('cart:refresh')); }); });
  document.addEventListener('cart:item-added', function () { setTimeout(startNormalize, 300); });
  // Checkout: normalize first, then go.
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest('button[name="checkout"], a[href^="/checkout"], [data-lx-checkout], [data-asc-cd-checkout]');
    if (!el || el.getAttribute('data-moq-ok') === '1') return;
    e.preventDefault(); e.stopImmediatePropagation();
    normalizeCart().then(function () {
      el.setAttribute('data-moq-ok', '1');
      if (el.tagName === 'A') { location.href = el.getAttribute('href'); } else { el.click(); }
      setTimeout(function () { el.removeAttribute('data-moq-ok'); }, 3000);
    });
  }, true);
  window.ascMoq = { baseUnit: baseUnit, snap: snap, applyAll: applyAll, unitsForCart: unitsForCart, normalizeCart: normalizeCart };
})();
